import actions from "./action_types.js";
import axios from "axios";

export default {
    [actions.SUBMIT_CONTRACT_FORM]: function (store, formData) {
        return axios.post('/records/contracts', formData)
    },
    [actions.SUBMIT_UPDATE_CONTRACT_FORM]:async function (store, payload) {
        let [id, formData] = payload;
        formData.append('_method', 'PUT');
        return axios.post('/records/contracts/' + id, formData)
    },
    [actions.INCLUDE_IN_INCOME_EXPENSES]: function (store, contractId) {
        return axios.post(`/records/contracts/include-in-income-expenses/${contractId}`)
    },
    [actions.REVOKE_RECOGNITION_OF_INCOME_EXPENSES]: function (store, contractId) {
        return axios.post(`/records/contracts/revoke-recognition-of-income-expenses/${contractId}`)
    },
}
